import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { useLocation, useNavigate } from 'react-router-dom';

import { ScreenBackV2WithTitle } from '../../../Components/ScreenBackV2';
import OnboardingContainer from '../../Component/OnboardingContainer';
import { getOnboardingIndustryAction } from '../../auth/action';
import IndustryCard from '../../Component/industryCard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SubIndustrySelect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const industry = location.state?.industry || null;
  const [subIndustries, setSubIndustries] = useState([]);

  const getIndustry = async () => {
    const { data, error, message } = await getOnboardingIndustryAction(
      industry.id,
    );

    if (!error) {
      setSubIndustries(data);
    } else return toast.error(message);
  };

  useEffect(() => {
    getIndustry();
  }, []);

  const handleSubIndustryClick = (subIndustry) => {
    navigate('/CompanyAndRoleSelect', {
      state: {
        industry: industry,
        subIndustry: subIndustry,
      },
    });
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Select Sub Industry'} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mt: '2rem',
          height: window.innerHeight * 0.6,
          overflowY: 'auto',
        }}
      >
        {subIndustries.map((subIndustry) => (
          <IndustryCard
            key={subIndustry.id}
            industryData={subIndustry}
            onClick={() => handleSubIndustryClick(subIndustry)}
          />
        ))}
      </Box>
    </OnboardingContainer>
  );
};

export default SubIndustrySelect;
